<template>
    <div class="page-table mainDiv" id="affix-container">
        <div class="card-base baslikBg animated fadeInUp">
            Ürün Malzeme İşlemleri
        </div>
        <el-row :gutter="10">
            <el-col :lg="18" :md="18" :sm="24" :xs="24">
                <div class="page-header card-base card-shadow--medium animated fadeInUp">
                    <div class="padding-bottom-10">
                        <el-radio-group size="small" v-on:change="handleChange($event)" v-model="radio" fill="#E5F5F9"
                                        text-color="gray">
                            <el-radio-button label="1">
                                <i class="mdi mdi-circle-edit-outline mdi-18px" style="color: #13ce66; margin-right: 5px"></i>
                                <transition
                                        name="slide-fade"><label v-if="selectIcon==='1'">Aktif Ürün Malzeme</label>
                                </transition>
                            </el-radio-button>
                            <el-radio-button label="0">
                                <i class="mdi mdi-circle-edit-outline  mdi-18px" style="color: #ec205f; margin-right: 5px"></i>
                                <transition
                                        name="slide-fade"><label v-if="selectIcon==='0'">Pasif Ürün Malzeme</label>
                                </transition>
                            </el-radio-button>
                        </el-radio-group>
                    </div>
                    <el-table
                            :data="urunMalzemeListesi"
                            border
                            stripe
                            style="width: 100%">
                        <el-table-column
                                label="Sıra"
                                type="index"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                prop="baslik"
                                label="Ürün Adı"
                                width="auto">
                        </el-table-column>
                        <el-table-column
                                prop="fiyat"
                                label="Fiyat"
                                width="auto">
                        </el-table-column>
                        <el-table-column
                                label="İşlem"
                                align="right"
                                width="250">
                            <template slot="header" slot-scope="scope">
                                <el-input clearable v-on:clear="clearable" v-model="search" v-on:input="searchMethod"
                                          placeholder="Ara" size="mini"></el-input>
                            </template>
                            <template slot-scope="scope">
                                <el-tooltip :content='$t("src.views.apps.haberler.kategori.liste.duzenle")'
                                            :open-delay="500"
                                            placement="bottom">
                                    <el-button
                                            v-on:click="selectionIndex=scope.$index; selection=scope.row; updateStart(scope.row); "
                                            type="text"
                                            class="buttonEdit"
                                            icon="el-icon-edit">
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip :content='$t("src.views.apps.firma.yonetici.liste.yoneticiaktif")'
                                            :open-delay="500"
                                            placement="bottom">
                                    <el-button
                                            v-if="selectIcon==='0'"
                                            @click="durumChange(scope.row,scope.$index,urunMalzemeListesi,1)"
                                            type="text"
                                            icon="mdi mdi-play mdi-24px">
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip :content='$t("src.views.apps.haberler.kategori.liste.sil")'
                                            :open-delay="500"
                                            placement="bottom">
                                    <el-button
                                            v-if="selectIcon==='1'"
                                            v-on:click="dialogVisible = true; selection=scope.row; selectionIndex=scope.$index"
                                            type="text"
                                            class="buttonDel"
                                            icon="mdi mdi-delete mdi-24px">
                                    </el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                            background
                            layout="sizes,prev, pager, next, jumper, total"
                            :total="total"
                            @size-change="handleSizeChange"
                            @current-change="pageChange"
                            :page-sizes="[10, 20, 50, 100]"
                            :current-page.sync="page"
                            :next-click.sync="page"
                            :prev-click.sync="page"
                            @next-click="pageChange"
                            @prev-click="pageChange">
                    </el-pagination>
                </div>

            </el-col>
            <el-col :lg="6" :md="6" :sm="24" :xs="24">
                <el-form status-icon label-position="top" :model="malzemeForm" :rules="rulesMalzeme" ref="malzemeForm" @submit.native.prevent="enter"
                         class="demo-ruleForm">
                    <div class="card-base card-shadow--medium demo-box bg-white animated fadeInUp">
                        <el-row>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item label='Başlık :'
                                              prop="baslik">
                                    <el-input size="small"
                                              v-model="malzemeForm.baslik"
                                              placeholder='Başlık Giriniz'></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item label='Ücret Durumu:'
                                              prop="ucret">
                                    <el-switch
                                            v-model="malzemeForm.ucretDurum"
                                            active-text="Ücretli"
                                            inactive-text="Ücretsiz"
                                            active-value="1"
                                            inactive-value="2">
                                    </el-switch>
                                </el-form-item>
                            </el-col>
                            <el-col v-if="malzemeForm.ucretDurum === '1'" :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item label='Fiyat:'
                                              prop="fiyat">
                                    <el-input size="small"
                                              v-model="malzemeForm.fiyat"
                                              placeholder='Fiyat Giriniz'></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row class="col-p">
                            <el-form-item>
                                <el-button v-if="btnVisible" size="small" v-on:click="malzemeFormTanimlama('malzemeForm')"
                                           type="primary">
                                    Tanımla
                                </el-button>
                                <el-button v-else size="small" v-on:click="guncelleme('malzemeForm')" type="primary">
                                    Güncelle
                                </el-button>
                                <el-button v-if="!btnVisible" size="small" v-on:click="vazgec('malzemeForm')">
                                    Vazgeç
                                </el-button>
                            </el-form-item>
                        </el-row>
                    </div>


                    <el-collapse v-model="activeCollapse" class="yanForm animated fadeInUp margin-top-10">
                        <el-collapse-item class="card-shadow--medium"
                                          title='Kategori' name="2">
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item label="" prop="kategoriList">
                                        <el-tree
                                                class="baskaTree"
                                                :data="treeList"
                                                @check="handleNodeClick"
                                                :default-checked-keys="checkedKeysKategori"
                                                check-strictly
                                                node-key="id"
                                                ref="tree"
                                                icon-class
                                                show-checkbox
                                                :props="defaultProps">
                                        </el-tree>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                    </el-collapse>
                </el-form>
            </el-col>
        </el-row>
        <el-dialog
                :title='$t("src.views.apps.haberler.liste.uyari")'
                :visible.sync="dialogVisible"
                width="30%"
                center>
            <span>"{{selection["baslik"]}}" malzemeunu silmek istediğinize emin misiniz?</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="durumChange(selection,selectionIndex,urunMalzemeListesi,0), dialogVisible = false"></el-button>
                    <el-button size="mini" type="danger" icon="el-icon-close"
                               @click="dialogVisible = false"></el-button>
                </span>
        </el-dialog>
    </div>
</template>

<script>
    import urunService from '../../../../WSProvider/UrunService'
    import notification from '../../../../notification'
    import EventBus from '@/components/event-bus'

    export default {
        name: "MalzemeIslem",
        mounted() {
            let self = this;
            EventBus.$on('malzemeList', function(bool){
                if(bool){
                    self.getMalzemeListesi();
                    self.markaCount();
                }
            });
            this.getMalzemeListesi();
            this.markaCount();
            this.getTreeList();
        },
        data() {
            return {
                search: '',
                kategoriListesi: [],
                page: 0,
                sizes: 10,
                postPage: 0,
                total: null,
                selectIcon: '1',
                radio: '1',
                activeCollapse: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
                urunMalzemeListesi: [],
                updateKodu: '',
                btnVisible: true,
                selection: '',
                selectionIndex: '',
                dialogVisible: false,
                duzenleBtnVisible: true,
                VisibleA: false,
                linkVisible: false,
                linkChange: true,
                disabled: false,
                treeList: [],
                updateData: [],
                updateDataEN: '',
                updateDataDE: '',
                updateDataKat: [],
                malzemeFormKlon: {},
                defaultProps: {
                    id: 'id',
                    children: 'children',
                    label: 'name'
                },
                checkedKeysKategori: [],
                oldKategoriList: [],

                malzemeForm: {
                    baslik: "",
                    ucretDurum: "1",
                    fiyat: "",
                    kategoriList: [],
                    durum: "1",
                },
                rulesMalzeme: {
                    baslik: [{
                        required: true,
                        message: "Lütfen Malzeme Giriniz",
                        trigger: 'blur'
                    }],
                },
            }
        },
        methods: {
            searchMethod(val) {
                if (val !== '') {
                    var dizi = [];
                    urunService.urunMalzemeArama(this.selectIcon,val).then((response) => {
                        if (response.status === 200) {
                            response.data.forEach(function (e) {
                                dizi.push(e);
                            });
                            this.urunMalzemeListesi = dizi;
                        } else notification.Status(response.status, this)
                    })
                } else this.clearable();
            },
            clearable() {
                this.urunMalzemeListesi = [];
                this.getMalzemeListesi();
                this.markaCount();
            },
            getTreeList() {
                urunService.kategoriTree().then((response) => {
                    if (response.status === 200) {
                        this.treeList = response.data;
                    } else {
                        notification.Status(response.status, this);
                    }
                })
            },
            handleNodeClick(data, checked, indeterminate) {
                let self = this;
                this.malzemeForm.kategoriList = [];
                Object.values(checked.checkedNodes).forEach(function (e) {
                    self.malzemeForm.kategoriList.push(e.id);
                })
                Object.values(checked.halfCheckedNodes).forEach(function (e) {
                    self.malzemeForm.kategoriList.push(e.id);
                })
            },
            handleSizeChange(val) {
                this.sizes = val;
                this.getMalzemeListesi();
            },
            handleChange(event) {
                this.selectIcon = event;
                this.markaCount();
                this.getMalzemeListesi();
            },
            markaCount() {
                urunService.umalzemeList(this.selectIcon,"","").then((response) => {
                    if (response.status === 200) {
                        this.total = response.data.length;
                    }
                });
            },
            pageChange(val) {
                this.postPage = (val - 1) * this.sizes;
                this.getMalzemeListesi();
            },
            getMalzemeListesi() {
                urunService.umalzemeList(this.selectIcon, this.postPage, this.sizes).then((response) => {
                    if (response.status === 200) {
                        this.urunMalzemeListesi = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            updateStart(scope) {
                let self = this;
                this.malzemeForm.baslik = scope.baslik;
                this.malzemeForm.ucretDurum = scope.ucretDurum;
                this.malzemeForm.fiyat = scope.fiyat;
                this.malzemeFormKlon.baslik = scope.baslik;
                this.malzemeFormKlon.ucretDurum = scope.ucretDurum;
                this.malzemeFormKlon.fiyat = scope.fiyat;

                this.oldKategoriList = scope.kategori;
                if (scope.kategori) {
                    self.checkedKeysKategori = []
                    self.malzemeForm.kategoriList = []
                    scope.kategori.forEach(function (e) {
                        self.malzemeForm.kategoriList.push(e.ukategoriId)
                        self.checkedKeysKategori.push(e.ukategoriId)
                    })
                    this.$nextTick(() => {
                        this.$refs.tree.setCheckedKeys(self.checkedKeysKategori);
                    });
                }
                this.updateKodu = scope.umalzemeId;
                this.btnVisible = false;
            },
            vazgec(formName) {
                this.$refs[formName].resetFields();
                this.$refs.tree.setCheckedKeys([]); // tree checked temizleme
                this.btnVisible = true;
            },
            enter() {
                if (this.btnVisible) {
                    this.malzemeFormTanimlama('malzemeForm');
                } else this.guncelleme('malzemeForm')
            },
            malzemeFormTanimlama(formName) {
                let dil = [];
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        urunService.umalzemeTanimlama(this.malzemeForm.baslik, this.malzemeForm.fiyat, this.malzemeForm.ucretDurum, this.malzemeForm.kategoriList,  this.malzemeForm.durum, dil).then((response) => {
                            if (response.status === 200) {
                                this.urunMalzemeListesi.push(response.data);
                                notification.Status('success', this, 'Ürün malzeme başarıyla eklendi.');
                                this.malzemeForm.kategoriList = [];
                                this.$refs.tree.setCheckedKeys([]); // tree checked temizleme
                                this.$refs[formName].resetFields();
                                EventBus.$emit("malzemeList", true)
                            } else if (response.status === 230) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir ürün malzeme zaten mevcut');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    }
                })
            },
            guncelleme(formName) {
                let self = this;
                console.log("malzeme form klona: ", this.malzemeFormKlon) 
                console.log("malzeme form güncellenecek: ", this.malzemeForm) 
                for (var key in this.malzemeFormKlon) {
                    if (this.malzemeFormKlon[key] !== this.malzemeForm[key]) { // değişim varsa kontrolu yapılıyor.
                        if (this.malzemeForm[key] || this.malzemeForm[key] === '') {
                            var item = {
                                type: key,
                                value: this.malzemeForm[key]
                            };
                            this.updateData.push(item);
                        }
                        
                    }
                }
                for (var ii = 0; ii < self.malzemeForm.kategoriList.length; ii++) {
                    let obj11 = self.oldKategoriList.find(data => data.ukategoriId === self.malzemeForm.kategoriList[ii]);
                    if (obj11 === undefined) {
                        self.updateData.push({
                            type : "malzeme",
                            value : {
                                durum: 1,
                                ukategoriId: self.malzemeForm.kategoriList[ii],
                            }
                        });
                    }
                }
                for (var jj = 0; jj < this.oldKategoriList.length; jj++) {
                    let obj00 = self.malzemeForm.kategoriList.find(data => data === self.oldKategoriList[jj].ukategoriId);
                    if (obj00 === undefined) {
                        self.updateData.push({
                            type : "malzeme",
                            value : {
                                durum: 0,
                                ukategoriId: self.oldKategoriList[jj].ukategoriId,
                            }
                        })
                    }
                }
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.updateData.length !== 0) {
                            urunService.umalzemeGuncelle(this.updateKodu, this.updateData).then((response) => {
                                if (response.status === 200) {
                                    this.urunMalzemeListesi.splice(this.selectionIndex, 1);
                                    this.urunMalzemeListesi.splice(this.selectionIndex, 0, {
                                        baslik: response.data.baslik,
                                        ucretDurum: response.data.ucretDurum,
                                        fiyat: response.data.fiyat,
                                        umalzemeId: response.data.umalzemeId
                                    });
                                    notification.Status('success', this, 'Malzeme başarıyla güncellendi...');
                                    // EventBus.$emit("malzemeList", true)
                                    this.$refs[formName].resetFields();
                                    this.$refs.tree.setCheckedKeys([]); // tree checked temizleme
                                    this.btnVisible = true;
                                    this.getMalzemeListesi()
                                } else if (response.status === 200) {
                                    notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir malzeme zaten mevcut');
                                } else {
                                    notification.Status(response.status, this)
                                }
                            });
                        }
                        if (self.updateData.length === 0) {
                            notification.Status('warning', this, 'Herhangi bir değişiklik yapılmadı');
                        }
                    }
                })
            },
            durumChange(selection, index, list, durum) {
                urunService.umalzemeDurumGuncelle(selection.umalzemeId, durum).then((response) => {
                    if (response.status === 200) {
                        notification.Status('success', this, 'Ürün durumu başarıyla değiştirildi.');
                        list.splice(index, 1);
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
        }
    }

</script>


<style scoped>
    .el-pagination {
        margin-top: 20px;
        float: right;
    }

</style>
